import { render, staticRenderFns } from "./clientKycModal.vue?vue&type=template&id=0df75eb4&scoped=true&"
import script from "./clientKycModal.vue?vue&type=script&lang=js&"
export * from "./clientKycModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df75eb4",
  null
  
)

export default component.exports